import { render } from "./App.vue?vue&type=template&id=6f155475"
const script = {}

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__